import * as types from '../actions/action-types';

const acknowledgedMessageReducer = (state = {}, action) => {
  if (action.type === types.UPDATE_ACKNOWLEDGED_MESSAGE) {
    return {...state, ...action.payload};
  }
  return state;
};

export default acknowledgedMessageReducer;
